// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes moveRight{0%{right:-100%}to{right:7.5rem}}", ""]);
// Exports
module.exports = exports;
